function cov_wrfcgex80() {
  var path = "/app/src/utils/get-translation-fn.ts";
  var hash = "e4d70ece6713310cc9ffb2cd5a37358626f5627f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-translation-fn.ts",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "2": {
        start: {
          line: 29,
          column: 16
        },
        end: {
          line: 30,
          column: 55
        }
      },
      "3": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 55
        }
      },
      "4": {
        start: {
          line: 32,
          column: 26
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "5": {
        start: {
          line: 36,
          column: 19
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "6": {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 38,
          column: 68
        }
      },
      "7": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "8": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 43
        }
      },
      "9": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 44,
          column: 59
        }
      },
      "10": {
        start: {
          line: 47,
          column: 23
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "11": {
        start: {
          line: 48,
          column: 25
        },
        end: {
          line: 48,
          column: 56
        }
      },
      "12": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 37
        }
      },
      "13": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 53
        }
      },
      "14": {
        start: {
          line: 55,
          column: 29
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "15": {
        start: {
          line: 61,
          column: 22
        },
        end: {
          line: 61,
          column: 57
        }
      },
      "16": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 63,
          column: 34
        }
      },
      "17": {
        start: {
          line: 63,
          column: 15
        },
        end: {
          line: 63,
          column: 34
        }
      },
      "18": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 68,
          column: 4
        }
      },
      "19": {
        start: {
          line: 66,
          column: 19
        },
        end: {
          line: 66,
          column: 50
        }
      },
      "20": {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 83,
          column: 3
        }
      },
      "21": {
        start: {
          line: 73,
          column: 2
        },
        end: {
          line: 83,
          column: 3
        }
      },
      "22": {
        start: {
          line: 78,
          column: 30
        },
        end: {
          line: 78,
          column: 79
        }
      },
      "23": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 82,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 29,
            column: 16
          },
          end: {
            line: 29,
            column: 17
          }
        },
        loc: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 55
          }
        },
        line: 30
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 32,
            column: 26
          },
          end: {
            line: 32,
            column: 27
          }
        },
        loc: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 35
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 47,
            column: 23
          },
          end: {
            line: 47,
            column: 24
          }
        },
        loc: {
          start: {
            line: 47,
            column: 78
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 47
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 55,
            column: 29
          },
          end: {
            line: 55,
            column: 30
          }
        },
        loc: {
          start: {
            line: 60,
            column: 5
          },
          end: {
            line: 69,
            column: 1
          }
        },
        line: 60
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        loc: {
          start: {
            line: 66,
            column: 19
          },
          end: {
            line: 66,
            column: 50
          }
        },
        line: 66
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 7
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 77
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 17
          },
          end: {
            line: 29,
            column: 28
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 26
          },
          end: {
            line: 29,
            column: 28
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 30
          },
          end: {
            line: 29,
            column: 41
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 39
          },
          end: {
            line: 29,
            column: 41
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 43
          },
          end: {
            line: 29,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 49
          },
          end: {
            line: 29,
            column: 51
          }
        }],
        line: 29
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 21
          },
          end: {
            line: 38,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 21
          },
          end: {
            line: 38,
            column: 27
          }
        }, {
          start: {
            line: 38,
            column: 31
          },
          end: {
            line: 38,
            column: 68
          }
        }],
        line: 38
      },
      "4": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 40
      },
      "5": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 43
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 59,
            column: 39
          },
          end: {
            line: 59,
            column: 43
          }
        }],
        line: 59
      },
      "6": {
        loc: {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 63,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 63,
            column: 34
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 63
      },
      "7": {
        loc: {
          start: {
            line: 80,
            column: 11
          },
          end: {
            line: 82,
            column: 25
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 68
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 25
          }
        }],
        line: 80
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e4d70ece6713310cc9ffb2cd5a37358626f5627f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_wrfcgex80 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_wrfcgex80();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* https://tyapk.ru/blog/post/correct-way-to-import-lodash-methods */
import get from 'lodash.get';
import arDictionaryContent from 'src/locales/ar.json';
import enDictionaryContent from 'src/locales/en.json';
import { LangDictionary, Locale } from 'src/types/lang-locale-type';
import { getLangCode } from 'src/utils/get-lang-code';
import { getLocale } from 'src/utils/get-locale';
import { replaceStringTagToComponent } from 'src/utils/replace-string-tag-to-component';
var dictionaryContent = (cov_wrfcgex80().s[0]++, _defineProperty(_defineProperty({}, LangDictionary.en, enDictionaryContent), LangDictionary.ar, arDictionaryContent));
var LocaleDictionaryMap = (cov_wrfcgex80().s[1]++, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Locale['en-US'], LangDictionary.en), Locale['ar-AE'], LangDictionary.ar), Locale['ar-BH'], LangDictionary.ar), Locale['ar-KW'], LangDictionary.ar), Locale['ar-SA'], LangDictionary.ar), Locale['ar-QA'], LangDictionary.ar));
cov_wrfcgex80().s[2]++;
var replace = function replace() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_wrfcgex80().b[0][0]++, '');
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_wrfcgex80().b[1][0]++, '');
  var val = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_wrfcgex80().b[2][0]++, '');
  cov_wrfcgex80().f[0]++;
  cov_wrfcgex80().s[3]++;
  return source.replace(new RegExp("{{".concat(target, "}}"), 'g'), val);
};
cov_wrfcgex80().s[4]++;
var getDictionaryName = function getDictionaryName(lang, locale) {
  cov_wrfcgex80().f[1]++;
  var langCode = (cov_wrfcgex80().s[5]++, getLangCode(lang));
  var localeCode = (cov_wrfcgex80().s[6]++, (cov_wrfcgex80().b[3][0]++, locale) || (cov_wrfcgex80().b[3][1]++, getLocale(langCode, locale)));
  cov_wrfcgex80().s[7]++;
  if (localeCode in LocaleDictionaryMap) {
    cov_wrfcgex80().b[4][0]++;
    cov_wrfcgex80().s[8]++;
    return LocaleDictionaryMap[localeCode];
  } else {
    cov_wrfcgex80().b[4][1]++;
  }
  cov_wrfcgex80().s[9]++;
  throw new Error("Unexpected locale code: ".concat(localeCode));
};
cov_wrfcgex80().s[10]++;
var getTranslation = function getTranslation(lang, locale, value) {
  cov_wrfcgex80().f[2]++;
  var dictionaryName = (cov_wrfcgex80().s[11]++, getDictionaryName(lang, locale));
  var currentDictionaryContent = (cov_wrfcgex80().s[12]++, dictionaryContent[dictionaryName]);
  cov_wrfcgex80().s[13]++;
  return get(currentDictionaryContent, value, value);
};
cov_wrfcgex80().s[14]++;
var getTranslationString = function getTranslationString(lang, locale, value) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (cov_wrfcgex80().b[5][0]++, null);
  cov_wrfcgex80().f[3]++;
  var translation = (cov_wrfcgex80().s[15]++, getTranslation(lang, locale, value));
  cov_wrfcgex80().s[16]++;
  if (!params) {
    cov_wrfcgex80().b[6][0]++;
    cov_wrfcgex80().s[17]++;
    return translation;
  } else {
    cov_wrfcgex80().b[6][1]++;
  }
  cov_wrfcgex80().s[18]++;
  return Object.keys(params).reduce(function (prev, key) {
    cov_wrfcgex80().f[4]++;
    cov_wrfcgex80().s[19]++;
    return replace(prev, key, params[key]);
  }, translation);
};
cov_wrfcgex80().s[20]++;
export var getTranslationFn = function getTranslationFn(lang, locale) {
  cov_wrfcgex80().f[5]++;
  cov_wrfcgex80().s[21]++;
  return function (value, params, сomponetsMap) {
    cov_wrfcgex80().f[6]++;
    var translationString = (cov_wrfcgex80().s[22]++, getTranslationString(lang, locale, value, params));
    cov_wrfcgex80().s[23]++;
    return сomponetsMap ? (cov_wrfcgex80().b[7][0]++, replaceStringTagToComponent(translationString, сomponetsMap)) : (cov_wrfcgex80().b[7][1]++, translationString);
  };
};